export const CHANGE_SEARCH_FIELD = 'CHANGE_SEARCH_FIELD';

export const FEETCH_ROBOTS_PENDING = 'FEETCH_ROBOTS_PENDING';
export const FEETCH_ROBOTS_SUCCESS = 'FEETCH_ROBOTS_SUCCESS';
export const FEETCH_ROBOTS_FAILED = 'FEETCH_ROBOTS_FAILED';